import es from "date-fns/locale/es";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import "./AcumuladoresTab.scss";
import BorradoresActos from "../borradoresActos/BorradoresActos";
import ActosPresentados from "../actosPresentedos/ActosPresentados";
import { useState } from "react";

registerLocale("es", es);
const AcumuladoresTabActosAdmin = ({
  borradores,
  setBorradores,
  setActosPresentados,
  actosPresentados,
  loading,
  errorBorrador,
  errorPresentada,
  handleActualizarPresentada,
  accesoPDF
}) => {
  const [selectedIndex, setSelectedIndex] = useState(accesoPDF ? 1 : 0);

  
  
  

  const handleTabSelect = (index) =>{
    setSelectedIndex(index);
  }
  const displayTabs = () => {
    return (
      <Tabs
        selectedIndex={selectedIndex}
        onSelect={handleTabSelect}
        selectedTabClassName="tab-selected"
      >
        <TabList className={"row align-items-center"}>
            <Tab className={"col-5 col-md-3 col-sm-2 py-1 cursorPointer"}><h3 className="tituloAccesibilidadTab">Borradores</h3></Tab> 
            <Tab className={"col-7 col-md-5 col-sm-3 py-1 cursorPointer"}><h3 className="tituloAccesibilidadTab">Actos Presentados</h3></Tab>
        </TabList>
        
        {loading.borradores && loading.solicitudes ? (
          <>
            <>
              <TabPanel>
                <div className="acumulador-tab-panel">
                  <BorradoresActos
                    borradores={borradores}
                    setBorradores={setBorradores}
                    loading={loading.borradores}
                    error={errorBorrador}
                  />
                </div>
              </TabPanel>
            </>

            <TabPanel>
              <div className="acumulador-tab-panel">
                <ActosPresentados
                  actosPresentados={actosPresentados}
                  setActosPresentados={setActosPresentados}
                  loading={loading.actosPresentados}
                  error={errorPresentada}
                  handleActualizarPresentada={handleActualizarPresentada}
                />
              </div>
            </TabPanel>
          </>
        ) : (
          <>
            <SpinnerCircle></SpinnerCircle>
          </>
        )}
      </Tabs>
    );
  };

  return (
    <>
      <div className="acumuladoresTab col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div>{displayTabs()}</div>
      </div>
    </>
  );
};
export default AcumuladoresTabActosAdmin;
